(function () {
  'use strict';

  function initAboutHero(section) {
    if (!section || section.dataset.aboutHeroInit === 'true') return;

    section.dataset.aboutHeroInit = 'true';

    var revealItems = section.querySelectorAll('.reveal-item');

    revealItems.forEach(function (item, index) {
      if (!item.style.transitionDelay && !item.className.match(/delay-/)) {
        item.style.transitionDelay = index * 120 + 'ms';
      }
    });

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      var parent = section.querySelector('.reveal-parent');
      if (parent) parent.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');

            var parent = section.querySelector('.reveal-parent');
            if (parent) parent.classList.add('is-visible');

            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0.25
      }
    );

    observer.observe(section);
  }

  function initAllAboutHeroes() {
    document.querySelectorAll('.about-hero').forEach(initAboutHero);
  }

  document.addEventListener('DOMContentLoaded', initAllAboutHeroes);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.about-hero');
    if (section) initAboutHero(section);
  });
})();